import { Model } from '../base.model';
import { InformerPosition, InvoiceStateColor, InvoiceStateStatus } from '../../services/invoices/invoice-states.config';

export class InvoiceState extends Model {
  name: string;
  shortName?: InvoiceStateStatus;
  note?: string;
  showNote?: boolean;
  color: InvoiceStateColor;
  progressPercent: number;
  informerIcon: string;
  informerPosition: InformerPosition;
}
